import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { placesClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation SetPlaceAvailabilityStatus($placeId: Int!, $status: PlaceAvailabilityStatusInput!, $reason: String) {
    setPlaceAvailabilityStatus(placeId: $placeId, status: $status, reason: $reason) {
      id
      availabilityStatus
      availabilityStatusOrigin
      availabilityStatusChangedAt
    }
  }
`

// The mutation's `status` argument is a real GraphQL enum (`AVAILABLE` / `UNAVAILABLE`),
// while every other place in the app (filters, trigger payloads) deals with the derived
// field as a lowercase string ("available" / "unavailable"). Keep that conversion here,
// in one place, instead of leaking enum casing into callers.
const toEnum = status => status?.toUpperCase()

export const useSetPlaceAvailabilityStatus = () => {
  const { t } = useTranslation('availability')
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Places', 'Place', 'PlaceAvailabilityDetails'],
    client: placesClient
  })

  const handleRequest = ({ placeId, status, reason }) => {
    return request({ variables: { placeId, status: toEnum(status), reason: reason || undefined } }).then(resp => {
      if (resp.errors) {
        notify.error({ title: t('changeStatusError') })
        return false
      }
      notify.success({ title: t('changeStatusSuccess') })
      return resp
    })
  }

  return [handleRequest, state]
}
